<!--
 * @Description:资源覆盖时效列表
 * @Author: luohuan
 * @Date: 2025-08-20 16:38:03
 * @LastEditTime: 2025-08-20 16:38:03
 * @LastEditors: luohuan
-->
<template>
  <div class="content-view-wrapper pd-10">
    <div
      class="content-view section-wrapper"
      ref="sectionWrapper"
      v-loading="loading"
      :element-loading-background="loadingBackground"
    >
      <!-- 搜索头部 start -->
      <table-title @resize="handleTableTitleResize">
        <template v-slot:searchForm>
          <el-form class="search-list" ref="searchForm" :model="searchForm">
            <el-form-item class="search-item--1" prop="regionalId">
              <e6-vr-select
                v-model="searchForm.regionalId"
                :data="regionalList"
                placeholder="大区名称"
                title="大区名称"
                clearable
                :props="{
                  id: 'areaId',
                  label: 'areaName'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item class="search-item--1" prop="areaId">
              <e6-vr-select
                v-model="searchForm.areaId"
                :data="areaList"
                placeholder="片区名称"
                title="片区名称"
                clearable
                :props="{
                  id: 'areaId',
                  label: 'areaName'
                }"
              ></e6-vr-select>
            </el-form-item>

            <el-form-item class="search-item--1" prop="timeLimitTypeList">
              <e6-vr-select
                v-model="searchForm.timeLimitTypeList"
                :data="timeLimitTypeList"
                placeholder="上门时效"
                title="上门时效"
                clearable
                multiple
                :loading="selectLoading"
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
              ></e6-vr-select>
            </el-form-item>

            <el-form-item class="search-item--1" prop="provinceId">
              <e6-vr-select
                v-model="searchForm.provinceId"
                :data="provinceList"
                placeholder="省"
                title="省"
                clearable
                virtual
                :is-title="true"
                :props="{
                  id: 'code',
                  label: 'name'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item class="search-item--1" prop="cityId">
              <e6-vr-select
                v-model="searchForm.cityId"
                :data="cityNameList"
                placeholder="市"
                title="市"
                clearable
                virtual
                :is-title="true"
                :props="{
                  id: 'code',
                  label: 'name'
                }"
              ></e6-vr-select>
            </el-form-item>
            <el-form-item class="search-item--1" prop="countyId">
              <e6-vr-select
                v-model="searchForm.countyId"
                :data="districtList"
                placeholder="区"
                title="区"
                clearable
                virtual
                :is-title="true"
                :props="{
                  id: 'code',
                  label: 'name'
                }"
              ></e6-vr-select>
            </el-form-item>

            <el-form-item class="search-item--buttons">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button class="reset" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template v-slot:operateAction>
          <i
            class="e6-icon-add_line"
            title="新增"
            @click="handleAdd"
            v-if="operationIds.includes(70)"
          ></i>
          <i
            class="e6-icon-edit_line"
            title="批量修改"
            @click="handleBatchEdit"
            v-if="operationIds.includes(71)"
          ></i>
          <i
            class="e6-icon-delete_line"
            title="批量删除"
            @click="handleBatchDelete"
            v-if="operationIds.includes(72)"
          ></i>
          <i class="e6-icon-export_line" title="导出" @click="exportData"></i>
        </template>
      </table-title>
      <!-- 搜索头部 end -->
      <!-- 表格 start -->
      <section class="table-wrapper">
        <el-table
          border
          :height="resizeViewHeight + 'px'"
          :data="tableData"
          highlight-current-row
          class="elTable"
          ref="elTable"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <!-- 序号 start -->
          <el-table-column
            label="序号"
            width="50"
            fixed="left"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.$index +
                    1 +
                    (searchForm.pageIndex - 1) * searchForm.pageSize
                }}
              </span>
            </template>
          </el-table-column>
          <!-- 序号 end -->
          <el-table-column
            show-overflow-tooltip
            v-for="(column, index) in columnData"
            :key="index"
            :prop="column.fieldName"
            :label="column.fieldLabel"
            :min-width="column.width"
            :fixed="column.fixed"
            :align="column.align"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <e6-td-operate
                :data="getOperateList(scope.row)"
                @command="handleOperate($event, scope.row)"
              ></e6-td-operate>
            </template>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->

      <!-- 分页 start -->
      <section class="pagination-wrapper fixed-section" ref="paginationWrapper">
        <el-pagination
          :page-size.sync="searchForm.pageSize"
          :current-page.sync="searchForm.pageIndex"
          :page-sizes="pageSizes"
          :layout="layout"
          :total="total"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </section>
      <!-- 分页 end -->
    </div>
    <addServiceProvider
      :addVisible.sync="addVisible"
      @refreshList="handleSearch"
      :clickRow="clickRow"
      :serviceIdList="serviceIdList"
      :addType="addType"
    ></addServiceProvider>
    <!-- 操作日志 -->
    <log-dialog
      :logVisible.sync="logVisible"
      :businessId="clickRow.serviceId"
      logType="1"
    ></log-dialog>
  </div>
</template>

<script>
import base from "@/mixins/base";
import listPage from "@/mixins/list-page";
import listPageReszie from "@/mixins/list-page-resize";
import { printError } from "@/utils/util";
// import { e3Api } from "@/config/api";
// const { E3_BL_EWOS = "" } = e3Api;
import {
  getAreaTimeLimitListPage,
  findDownList,
  exportAreaTimeLimitList,
  getAreaDown,
  getProviceList,
  deleteAreaTimeLimit
} from "@/api";
import addServiceProvider from "./addAreaTimeLimit.vue";
import { exportData } from "@/utils/download";
export default {
  name: "serviceProvider",
  data() {
    return {
      queryListAPI: getAreaTimeLimitListPage,
      regionalList: [], //大区名称
      areaList: [], //片区名称,
      provinceList: [],
      cityNameList: [],
      districtList: [],
      timeLimitTypeList: [],
      searchForm: {
        timeLimitTypeList: [],
        areaIdList: [],
        regionalIdList: [],
        areaId: null,
        regionalId: null,
        provinceId: null,
        cityId: null,
        countyId: null,
        pageIndex: 1,
        pageSize: 20
      },
      total: 0,
      loading: false,
      columnData: [
        {
          fieldName: "regionalName",
          display: true,
          fieldLabel: "大区名称",
          width: 120,
          disabled: false,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "areaName",
          display: true,
          fieldLabel: "片区名称",
          width: 120,
          disabled: false,
          fixed: false,
          align: "center"
        },

        {
          fieldName: "provinceName",
          display: true,
          fieldLabel: "省份名称",
          width: 120,
          disabled: false,
          fixed: false,
          align: "center"
        },

        {
          fieldName: "cityName",
          display: true,
          fieldLabel: "城市名称",
          width: 120,
          disabled: false,
          fixed: false,
          align: "center"
        },

        {
          fieldName: "countyName",
          display: true,
          fieldLabel: "县区名称",
          width: 120,
          disabled: false,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "timeLimitType",
          display: true,
          fieldLabel: "时效类型（T+n）",
          width: 150,
          disabled: false,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "timeLimitTypeName",
          display: true,
          fieldLabel: "时效类型名称",
          width: 150,
          disabled: false,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "userName",
          display: true,
          fieldLabel: "操作人",
          width: 120,
          disabled: false,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "updatedTime",
          display: true,
          fieldLabel: "修改时间",
          width: 160,
          disabled: false,
          fixed: false,
          align: "center"
        }
      ], //表头
      tableData: [], // 表格数据
      addVisible: false,
      serviceProviderTypeList: [],
      serviceProviderStatusList: [],
      isExamineList: [],
      addType: 1,
      clickRow: {},
      logVisible: false,
      serviceIdList: []
    };
  },
  mixins: [listPage, base, listPageReszie],
  components: {
    addServiceProvider
  },
  compute: {},
  watch: {
    "searchForm.regionalId": {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAreaDown();
          this.searchForm.regionalIdList = [val];
        } else {
          this.searchForm.regionalIdList = [];
          this.searchForm.areaId = "";
          this.areaList = [];
        }
      }
    },
    "searchForm.areaId": {
      immediate: true,
      handler(val) {
        if (val) {
          this.searchForm.areaIdList = [val];
        } else {
          this.searchForm.areaIdList = [];
        }
      }
    },

    "searchForm.provinceId": {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAreaList("-256", this.searchForm.provinceId);
        }
      }
    },
    "searchForm.cityId": {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAreaList("-1", this.searchForm.cityId);
        }
      }
    }
  },
  created() {
    this.initData();
    this.queryList();
    this.getAreaList("-65536", "");
  },
  mounted() {
    this.setTableScrollDOM("elTable");
  },
  activated() {
    this.setScrollRecord();
  },
  methods: {
    async initData() {
      try {
        this.selectLoading = true;
        let promiseList = [findDownList(["areaTimeLimitType"])];
        let [enumRes] = await Promise.all(promiseList);
        //上门时效
        this.timeLimitTypeList = this.getFreezeResponse(enumRes, {
          path: "data.areaTimeLimitType"
        });

        this.getAreaDown();
        //  this.getListRegionalAndArea(1);
      } catch (error) {
        printError(error);
      } finally {
        this.selectLoading = false;
      }
    },

    //获取大区/片区下拉框
    async getAreaDown() {
      let res = await getAreaDown({
        parentId: this.searchForm.regionalId
      });
      if (this.searchForm.regionalId) {
        this.areaList = res.data;
      } else {
        this.regionalList = res.data;
      }
    },

    //获取省市区下拉框数据
    async getAreaList(type, code) {
      console.log(type, code, "~~~");
      try {
        let res = await getProviceList({ type, code });
        switch (type) {
          case "-65536":
            this.provinceList = res.data;
            break;
          case "-256":
            this.cityNameList = res.data;
            break;
          case "-1":
            this.districtList = res.data;
            break;
          default:
            break;
        }
      } catch (error) {
        printError(error);
      }
    },

    // 获取页面操作权限
    getOperateList() {
      let operationIds = this.$route.meta.operationIds || [];
      // 页面按钮权限
      let operates = [
        {
          label: "编辑",
          id: 1,
          disabled: !operationIds.includes(71)
        },
        {
          label: "详情",
          id: 2
        }
      ];
      return operates;
    },
    // 操作--更多
    handleOperate(val, row) {
      this.clickRow = row;
      this.addVisible = val.id == 1 || val.id == 2 ? true : false;
      this.addType = val.id == 1 ? 2 : val.id == 2 ? 3 : "";
      this.logVisible = val.id == 3 ? true : false;
    },
    formatList(data) {
      data.map(item => {
        let province = item.province ? item.province : "";
        let city = item.city ? item.city : "";
        let country = item.country ? item.country : "";
        item.cityStr = province + city + country;
      });
      return data;
    },
    //新增
    handleAdd() {
      this.addVisible = true;
      this.addType = 1;
    },
    //表格选中数据
    handleSelectionChange(column) {
      this.serviceIdList = column.map(item => item.timeLimitId);
      this.serviceIdList = column.map(item => item.timeLimitId);
    },
    //批量修改
    handleBatchEdit() {
      if (!this.serviceIdList.length) {
        this.$message.warning("请先勾选数据");
        return;
      }
      this.addVisible = true;
      this.addType = 4;
    },

    handleBatchDelete() {
      if (!this.serviceIdList.length) {
        this.$message.warning("请先勾选数据");
        return;
      }
      this.delete();
    },
    //编辑
    async delete() {
      try {
        this.loading = true;
        let res = await deleteAreaTimeLimit({
          timeLimitIdList: this.serviceIdList
        });
        if (res.code == "OK") {
          this.$message.success("删除成功");
          this.queryList();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //  导出
    exportData() {
      exportData(this, exportAreaTimeLimitList);
    }
  }
};
</script>
<style lang="scss" scoped></style>
